// extracted by mini-css-extract-plugin
export default {"bioData":"BioForm_bioData__AcYJF","genderOptions":"BioForm_genderOptions__QYOHC"};